import { rightCount, revealMark } from '../lib/tagPick.js';

/**
 * The projector's side of a tag-pick question. Before the reveal it is just
 * the six name tags, so the class reads them while answering. At the reveal
 * the refused tags are struck out, every tag says why, and under each one
 * the instructor sees how many learners got it right — which rule to repeat.
 * Uses theme A's tag primitives (.nt), since only a theme A deck asks this.
 */
export default function HostTagPickPreview({ payload, revealed, tally }) {
  return (
    <div className="host-tagpick">
      {payload.items.map((item) => {
        const key = revealed && item.answer ? revealMark(item) : null;
        const bad = Boolean(key?.struck);
        const count = revealed ? rightCount(tally, item) : null;
        return (
          <div key={item.id} className={`host-tagpick-cell ${bad ? 'is-bad' : ''}`}>
            <span className={`nt ${bad ? 'is-struck' : ''}`}><span>{item.caption}</span></span>
            {key && (
              <span className="host-tagpick-why">
                <b aria-hidden="true">{key.mark}</b>
                {key.reason}
              </span>
            )}
            {count && (
              <span className="host-tagpick-count">ตอบถูก {count.right}/{count.of} คน</span>
            )}
          </div>
        );
      })}
    </div>
  );
}
